<app-modal-header [hasClose]='true' [title]="'ADICIONAR PROVAS'" (handleClose)="close()"></app-modal-header>

<mat-dialog-content class="content-dialog">

  <form [formGroup]="importTestForm">
    <div id="text" class="primary-text">
      Selecione a prova que deseja adicionar nessa aplicação.
    </div>

    <div class="flex">
      <mat-form-field class="half-input">
        <mat-select matSelect formControlName="regional_id" placeholder="DR" required>
          @for (dr of drArray; track dr) {
            <mat-option [value]="dr.id">
              {{dr.description}}
            </mat-option>
          }
        </mat-select>
        @if (importTestForm.get('regional_id').errors && importTestForm.get('regional_id').touched) {
          <mat-error>
          {{importTestForm.get('regional_id').errors['message']}}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="half-input">
        <mat-select matSelect formControlName="school_id" placeholder="Escola" required>
          @for (school of schoolArray; track school) {
            <mat-option [value]="school.id">
              {{school.description}}
            </mat-option>
          }
        </mat-select>
        @if (importTestForm.get('school_id').errors && importTestForm.get('school_id').touched) {
          <mat-error>
          {{importTestForm.get('school_id').errors['message']}}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex">
      <mat-form-field class="half-input">
        <mat-select matSelect formControlName="course_id" placeholder="Curso" required>
          @for (course of courseArray; track course) {
            <mat-option [value]="course.id">
              {{course.description}}
            </mat-option>
          }
        </mat-select>
        @if (importTestForm.get('course_id').errors && importTestForm.get('course_id').touched) {
          <mat-error>
          {{importTestForm.get('course_id').errors['message']}}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="half-input">
        <mat-select matSelect formControlName="exam_id" placeholder="Prova" required>
          @for (school of courseArray; track school) {
            <mat-option [value]="school.id">
              {{school.description}}
            </mat-option>
          }
        </mat-select>
        @if (importTestForm.get('exam_id').errors && importTestForm.get('exam_id').touched) {
          <mat-error>
          {{importTestForm.get('exam_id').errors['message']}}</mat-error>
        }
      </mat-form-field>
    </div>

  </form>

</mat-dialog-content>


<div class="modal-footer">
  <button id="modalApplyBtn" type="button" mat-raised-button color="accent" [disabled]="!importTestForm.valid" (click)="importTest()">
    Aplicar
  </button>
</div>
